import * as app from './app';
import * as cart from './cart';
import * as catalog from './catalog';
import * as checkout from './checkout';
import * as combo from './combo';
import * as content from './content';
import * as extendedCaptation from './extended-captation';
import * as order from './order';
import * as productDetail from './product-detail';
import * as router from './router';
import * as search from './search';
import * as sections from './sections';
import * as settings from './settings';
import * as shippingModel from './shippingModel';
import * as showcases from './showcases';
import * as user from './user';
import * as utilities from './utilities';
import * as version from './version';

export {
  app,
  cart,
  catalog,
  checkout,
  combo,
  content,
  extendedCaptation,
  order,
  router,
  search,
  sections,
  settings,
  showcases,
  user,
  utilities,
  version,
  shippingModel,
  productDetail,
};

export const notifications = {
  failure: {
    ...cart.notifications.failure.messages,
  },
  success: {
    ...cart.notifications.success.messages,
  },
} as const;
